
    export enum EnumFilterStatementConnector {
			And = 0,
			Or = 1,
    }